<template>
  <div id="app">
    <div>
      <div class="hello">
        <!-- head组件 -->
        <header-model></header-model>
        <!-- content 区域 -->
        <router-view v-if="isRouter"/>
        <!-- footer组件 -->
        <footer-model></footer-model>
        <online-service></online-service>
      </div>
    </div>
  </div>
</template>
<script>
import OnlineService from './layout/onlineService/onlineService'
import FooterModel from './layout/footer/footer'
import HeaderModel from './layout/header/unHeader'
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  components: {
    FooterModel,
    HeaderModel,
    OnlineService
  },
  data() {
    return {
      isRouter: true
    }
  },
  methods: {
    reload() {
      this.isRouter = false
      this.$nextTick(function() {
        this.isRouter = true
      })
    },
  },
  created(){
    
  },
  
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue